module.exports = {
  fetch: `query getAvatars {
    avatars {
      id
      key
      name {
        en
        es
      }
      selectionName {
        en
        es
      }
      picture {
        url
      }
      avatarOptions {
        upperUnderwear
        bodyType
        genderType
        defaultOutfit,
        defaultIslamicOutfit
      }
    }
  }`,
};
